/** @format */

import React from "react";

type titleProps = {
  title: string;
};

const FooterTitle = ({ title }: titleProps) => {
  return (
    <h3 className="font-bold text-[20px] leading-[27.28px] text-white">
     {title}
    </h3>
  );
};

export default FooterTitle;
